<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>员工中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">所有招聘岗位</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="!isHideDetails && !addHideIs && !editHideIs"
      style="position: relative;"
    >
      <section class="searchBox">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            style="margin-right:20px"
            @click="addHideIs = !addHideIs"
            >新增</a-button
          >
        </span>
        <div>
          <span>
            <label>行业：</label>
            <a-select
              v-model="trade_id"
              style="width: 100px"
              showSearch
              :filterOption="filterOption"
            >
              <a-select-option :value="-1">全部</a-select-option>
              <a-select-option
                v-for="(element, k) in tradeList"
                :value="element.id"
                :key="k"
                v-show="element.trade_name != '内部系统'"
                >{{ element.trade_name }}</a-select-option
              >
            </a-select>
          </span>
          <span>
            <label>类型：</label>
            <a-radio-group v-model="type">
              <a-radio :value="2">个人</a-radio>
              <a-radio :value="1">公共</a-radio>
            </a-radio-group>
          </span>
          <span>
            <label>岗位名称：</label>
            <a-input placeholder="请输入岗位名称" v-model="nameSearch" />
          </span>
          <a-button @click="onReset" class="resetStyle">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </div>
        <!-- <div>
          <span class="addStyle">
            <a-button type="primary" icon="cloud-download" @click="addHideIs=!addHideIs">任务处理</a-button>
          </span>
          <div></div>
        </div>
        <div class="searchTxt">
         
        </div>-->
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                <p v-show="item.type == 1">公共</p>
                <p v-show="item.type == 2">个人</p>
                <p v-show="item.type == 0">未知</p>
              </td>
              <td>{{ item.trade_name }}</td>
              <td style="width:15%">{{ item.name }}</td>
              <td>
                <p v-show="item.gender == 1">男</p>
                <p v-show="item.gender == 2">女</p>
                <p v-show="item.gender == 3">不限</p>
                <p v-show="item.gender == 0">未知</p>
              </td>
              <td>
                {{ item.work_time }}
              </td>
              <td style="width:25%">
                {{
                  item.requirement.length > 30
                    ? item.requirement.substring(0, 30) + "..."
                    : item.requirement
                }}
              </td>
              <td class="operation" style="width:15%">
                <a
                  style="color:#67C23A"
                  @click="editPage(item)"
                  v-show="item.type == 1"
                  >编辑</a
                >
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 增加 -->
    <addPost v-show="addHideIs" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 编辑 -->
    <postEdit
      v-show="editHideIs"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end -->
    <!-- 详情 -->
    <postDetail v-show="isHideDetails" :detailsStr="detailsStr" />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addPost from "@/components/resume/addPost"; //增加
import postEdit from "@/components/resume/postEdit"; //编辑
import postDetail from "@/components/resume/postDetail"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "类型",
        "行业",
        "岗位名称",
        "性别要求",
        "上班时间",
        "岗位要求",
        "操作"
      ],
      isHideDetails: false,
      detailsStr: {},
      nameSearch: "",
      addHideIs: false,
      editHideIs: false,
      editDetail: {},
      hideIsAssigned: false,
      resume_wish: "",
      tradeList: [],
      trade_id: -1,
      type: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addPost,
    postEdit,
    postDetail
  },
  mounted() {
    this.getTrade();
    this.getData(); //获取列表
  },
  methods: {
    getTrade() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "/Trade/tradeList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.tradeList = res.data.data.data;
          // console.log(this.tradeList);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAddOnline(isHide) {
      this.addHideIsOnline = isHide;
      this.reload();
    },
    detailPage(val) {
      this.detailsStr = val;
      this.isHideDetails = true;
    },
    hideInEdit(isShow) {
      this.editHideIs = isShow;
      this.reload();
    },
    onReset() {
      this.nameSearch = "";
      this.trade_id = -1;
      this.type = "";
      this.page = 1;
      this.getData();
    },
    hideInAdd(isHide) {
      this.addHideIs = isHide;
      this.reload();
    },
    backHref() {
      this.isHideDetails = false;
      this.addHideIs = false;
      this.editHideIs = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.recruitment +
        "Position/positionList";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.nameSearch,
        trade_id: this.trade_id,
        type: this.type,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      if (this.trade_id == -1) {
        delete params.trade_id;
      }
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            console.log(res);
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    editPage(val) {
      this.editDetail = val;
      this.editHideIs = true;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);

.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .resetStyle {
      margin-right: 10px;
    }
    span,
    > div {
      display: inline-block;
      //
      margin-right: 20px;
    }
    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .searchTxt {
      justify-content: flex-end;
    }
    input {
      margin: 0 10px;
      width: 160px;
    }
  }
}
.assignedBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  h3 {
    font-size: 14px;
    text-align: center;
    margin: 10px 0 20px;
  }
  > div {
    background: #fff;
    margin: 12% 30%;
    padding: 20px 4% 40px;
    border-radius: 10px;
    ul {
      li {
        margin-bottom: 10px;
        i {
          font-style: normal;
          color: red;
          display: inline-block;
          margin-right: 4px;
        }
      }
    }
    > div {
      margin-top: 30px;
      button {
        margin-right: 12px;
      }
    }
  }
}
.taskImg {
  height: 20px;
}
</style>
